// src/services/apis.js
import { api } from "./apiClient";

const extractFileNameFromContentDisposition = (contentDisposition = "") => {
	if (typeof contentDisposition !== "string" || contentDisposition.trim() === "") {
		return "";
	}

	const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
	if (utf8Match?.[1]) {
		try {
			return decodeURIComponent(utf8Match[1].trim());
		} catch (error) {
			return utf8Match[1].trim();
		}
	}

	const basicMatch = contentDisposition.match(/filename="([^"]+)"/i);
	if (basicMatch?.[1]) {
		return basicMatch[1].trim();
	}

	return "";
};

// ==============================
// MENU
// ==============================
export const getopcinesMenu = async () => {
	const res = await api.get("opcionesmenu.php");
	return res.data;
};

// ==============================
// TRABAJADORES
// ==============================
export const getTrabajadores = async (idProyecto = 0) => {
	const res = await api.get("trabajadores.php", { params: { idProyecto } });
	return res.data;
};

// ==============================
// FICHAJES
// ==============================
export const inicioFichaje = async (data) => {
	const res = await api.post("fichajes.php", { data });
	return res.data;
};

export const postCorregirFichaje = async (data) => {
	const res = await api.post("corregirFichaje.php", { data });
	return res.data;
};

export const fichajeTotem = async (data) => {
	const res = await api.post("fichajetotem.php", { data });
	return res.data;
};

export const getFichaje = async (fecha) => {
	const res = await api.get("fichajes.php", { params: { fecha } });
	return res.data;
};

export const finFichaje = async (data) => {
	// Tenías '??' y PUT a fichajes.php?? -> lo dejo correcto
	const res = await api.put("fichajes.php", { data });
	return res.data;
};

export const getTodosFichajes = async (fechaDesde, fechaHasta, usuarios) => {
	const res = await api.get("allfichajes.php", {
		params: { fechaDesde, fechaHasta, usuarios },
	});
	return res.data;
};

export const getTodosFichajesDescarga = async (fechaDesde, fechaHasta, usuarios) => {
	const res = await api.post("allfichajesdescarga.php", {
		fechaDesde,
		fechaHasta,
		usuarios,
	});
	return res.data;
};

export const getFichajesUsuario = async (mes, year, id) => {
	const res = await api.get("fichajeUsuario.php", { params: { mes, year, id } });
	return res.data;
};

// ==============================
// RRHH / USUARIOS
// ==============================
export const getOpcionesRrhh = async () => {
	const res = await api.get("opcionesrrhh.php");
	return res.data;
};

export const getUsuarios = async ({
	page = 1,
	limit = 25,
	search = "",
	rol = "",
	departamento = "",
} = {}) => {
	const res = await api.get("usuarios.php", {
		params: {
			page,
			limit,
			search,
			rol,
			departamento,
		},
	});
	return res.data;
};
export const getUsuariosMovil = async ({
	page = 1,
	limit = 25,
	search = "",
	rol = "",
	foto = "todas",
	activo = "todos",
	credenciales = "todos",
	documento = "",
	carpeta = "",
	estado_documento = "",
	fecha_documento_desde = "",
	fecha_documento_hasta = "",
	all = false,
	historial = false,
	historialLimit = 5,
} = {}) => {
	const res = await api.get("usuariosMovil.php", {
		params: {
			page,
			limit,
			search,
			rol,
			foto,
			activo,
			credenciales,
			documento,
			carpeta,
			estado_documento,
			fecha_documento_desde,
			fecha_documento_hasta,
			all: all ? 1 : 0,
			historial: historial ? 1 : 0,
			historial_limit: historialLimit,
		},
	});
	return res.data;
};
export const subirAvatarUsuario = async (id_usuario, foto) => {
	const formData = new FormData();
	formData.append("id_usuario", id_usuario);
	formData.append("foto", foto, foto?.name || "avatar.jpg");

	const res = await api.post("subirAvatar.php", formData);
	return res.data;
};
export const actualizarAvatarUsuario = async (id_usuario, foto) => {
	const formData = new FormData();
	formData.append("id_usuario", id_usuario);
	formData.append("foto", foto, foto?.name || "avatar.jpg");

	const res = await api.post("actualizarAvatar.php", formData);
	return res.data;
};
export const eliminarAvatarPersonaLuxand = async ({ id_usuario, id_imagen } = {}) => {
	const res = await api.post("eliminarAvatarPersonaLuxand.php", {
		id_usuario,
		id_imagen,
	});
	return res.data;
};
export const postUsuario = async (data) => {
	const res = await api.post("usuario.php", { data });
	return res.data;
};

export const delUsuario = async (id) => {
	const res = await api.delete("usuario.php", { data: { data: { id } } });
	return res.data;
};

export const actualizarUsuario = async (data) => {
	const res = await api.put("usuario.php", { data });
	return res.data;
};

export const actualizarCredencialesUsuario = async ({
	id_usuario,
	credenciales_activos,
	mail = "",
	contrasena = "",
} = {}) => {
	const res = await api.put("credencialesUsuario.php", {
		id_usuario,
		credenciales_activos,
		mail,
		contrasena,
	});
	return res.data;
};

// ==============================
// ADMIN / ROLES
// ==============================
export const getOpcionesAdmin = async () => {
	const res = await api.get("opcionesAdministrador.php");
	return res.data;
};

export const getPreparacionExportacionAccess = async () => {
	const res = await api.get("preparacionExportacionFichajes.php", {
		params: { accessOnly: 1 },
	});
	return res.data;
};

export const getPreparacionExportacionFichajes = async ({
	fechaDesde,
	fechaHasta,
	soloPendientes = true,
	search = "",
	criterioEstado = "todos",
	validado,
	revisado,
	page = 1,
	limit = 25,
} = {}) => {
	const res = await api.get("preparacionExportacionFichajes.php", {
		params: {
			fechaDesde,
			fechaHasta,
			soloPendientes: soloPendientes ? 1 : 0,
			search,
			criterioEstado,
			...(typeof validado === "boolean" ? { validado: validado ? 1 : 0 } : {}),
			...(typeof revisado === "boolean" ? { revisado: revisado ? 1 : 0 } : {}),
			page,
			limit,
		},
	});
	return res.data;
};

export const guardarPreparacionExportacionFichajes = async ({
	action = "prepare",
	items = [],
} = {}) => {
	const res = await api.post("preparacionExportacionFichajes.php", {
		action,
		items,
	});
	return res.data;
};

export const getRolesYDepartamentos = async () => {
	const res = await api.get("rolesydepartamentos.php");
	return res.data;
};

export const getEmpleadosProyectos = async () => {
	const res = await api.get("empleadosProyectos.php");
	return res.data;
};

export const actualizarRolesYDepartamentos = async (data, option, rolid) => {
	const res = await api.put("rolesydepartamentos.php", {
		data,
		option,
		rolid,
	});
	return res.data;
};

export const getPermisosOperativa = async () => {
	const res = await api.get("permisosOperativa.php");
	return res.data;
};

export const actualizarPermisosOperativa = async (data, option) => {
	const res = await api.put("permisosOperativa.php", {
		data,
		option,
	});
	return res.data;
};

export const getDelegacionesConfig = async () => {
	const res = await api.get("delegaciones.php");
	return res.data;
};

export const importarDelegacionesConfig = async ({ archivo, id_campana } = {}) => {
	const formData = new FormData();
	formData.append("id_campana", String(id_campana ?? ""));

	if (archivo instanceof File) {
		formData.append("archivo", archivo, archivo?.name || "delegaciones.json");
	}

	const res = await api.post("delegaciones.php", formData);
	return res.data;
};

export const actualizarDelegacionesConfig = async (payload = {}) => {
	const res = await api.put("delegaciones.php", payload);
	return res.data;
};

export const eliminarDelegacionesConfig = async (payload = {}) => {
	const res = await api.delete("delegaciones.php", {
		data: payload,
	});
	return res.data;
};

// ==============================
// CALENDARIO / JORNADAS
// ==============================
export const getTareasCalendario = async () => {
	const res = await api.get("tareasCalendario.php");
	return res.data;
};

export const getJornadas = async () => {
	const res = await api.get("jornadas.php");
	return res.data;
};

export const getTodosFichajesAuditoria = async (fechaDesde, fechaHasta, usuarios) => {
	const res = await api.post("allfichajesauditoria.php", {
		fechaDesde,
		fechaHasta,
		usuarios,
	});
	return res.data;
};

export const putTiempoTrabajadoTarea = async (data, id_tarea) => {
	const res = await api.put("actualizarTiempotrabajadoTarea.php", {
		data,
		id_tarea,
	});
	return res.data;
};

// ==============================
// VERSION / BUSQUEDAS / PENDIENTES
// ==============================
export const getVersion = async (versionLocal) => {
	const res = await api.get("controlVersion.php", {
		params: { versionLocal },
	});
	return res.data;
};

export const getTodasTareasInfoUnica = async (searchTerm) => {
	const res = await api.get("todastareas.php", {
		params: {
			id: null,
			tipo: 1,
			fechaDesde: "2000-01-29",
			fechaHasta: "2105-01-29",
			estados: "0,1,2,3,4",
			limit: 100,
			page: 1,
			empleados: null,
			clientes: null,
			proyectos: null,
			searchTerm,
		},
	});
	return res.data;
};

export const getFichajesPendientes = async () => {
	const res = await api.get("fichajesPendientes.php");
	return res.data;
};

export const updateFichajePendiente = async (data) => {
	const res = await api.put("fichajesPendientes.php", { data });
	return res.data;
};

export const updateAnularFichaje = async (data) => {
	const res = await api.put("anularFichaje.php", { data });
	return res.data;
};

// ==============================
// RECONOCIMIENTO / VALIDACION POR FOTO
// ==============================
export const cpPorFoto = async ({ id_cuadrilla, foto }) => {
	const formData = new FormData();
	formData.append("id_cuadrilla", String(id_cuadrilla ?? ""));
	formData.append("foto", foto, foto?.name || "foto.jpg");

	const res = await api.post("cpPorFoto.php", formData, {
		headers: {
			"X-Id-Cuadrilla": String(id_cuadrilla ?? ""),
		},
	});

	return res.data;
};

// ==============================
// TARJETAS
// ==============================
export const crearTarjeta = async (data) => {
	const res = await api.post("creartarjeta.php", { data });
	return res.data;
};

export const getTarjetaPorUsuario = async ({ id_usuario }) => {
	const res = await api.get("getTarjetaPorUsuario.php", { params: { id_usuario } });
	return res.data;
};

export const getUsuariosSinTarjeta = async () => {
	const res = await api.get("getUsuariosSinTarjeta.php");
	return res.data;
};

export const eliminarTarjeta = async (data) => {
	const res = await api.post("eliminarTarjeta.php", { data });
	return res.data;
};

// ==============================
// CUADRILLAS / FILTROS
// ==============================
export const getCuadrillas = async (fechaDesde, fechaHasta) => {
	// OJO: en tu código mandabas "data" dentro de params (raro).
	// Lo normal: params directos
	const res = await api.get("partesGrupo.php", {
		params: {
			fechaDesde,
			fechaHasta,
			_ts: Date.now(),
		},
	});
	return res.data;
};

export const getPartesOperativos = async ({ fechaDesde, fechaHasta } = {}) => {
	const res = await api.get("partesOperativos.php", {
		params: {
			fechaDesde,
			fechaHasta,
			_ts: Date.now(),
		},
	});
	return res.data;
};

export const actualizarPartesOperativos = async ({
	ids_cuadrilla = [],
	operativo = 1,
} = {}) => {
	const res = await api.post("partesOperativos.php", {
		ids_cuadrilla,
		operativo: Number(operativo),
	});
	return res.data;
};

export const getCampanasPartes = async ({
	id_campana,
	include_parts = false,
	include_assignments = false,
} = {}) => {
	const res = await api.get("campanasPartes.php", {
		params: {
			id_campana,
			include_parts: include_parts ? 1 : 0,
			include_assignments: include_assignments ? 1 : 0,
		},
	});
	return res.data;
};

export const crearCampanaPartes = async (payload = {}) => {
	const res = await api.post("campanasPartes.php", payload);
	return res.data;
};

export const actualizarCampanaPartes = async (payload = {}) => {
	const res = await api.put("campanasPartes.php", payload);
	return res.data;
};

export const eliminarCampanaPartes = async (id_campana) => {
	const res = await api.delete("campanasPartes.php", {
		data: { id_campana },
	});
	return res.data;
};

export const getDetalleParteGrupo = async (id_cuadrilla) => {
	const res = await api.get("detalleParteGrupo.php", {
		params: { id_cuadrilla },
	});
	return res.data;
};

export const updateParteGrupoEstado = async ({
	id_cuadrilla,
	validado,
	revisado,
	grabado,
	id_campana,
}) => {
	const payload = { id_cuadrilla };
	if (validado !== undefined) payload.validado = Number(validado);
	if (revisado !== undefined) payload.revisado = Number(revisado);
	if (grabado !== undefined) payload.grabado = Number(grabado);
	if (id_campana !== undefined) payload.id_campana = Number(id_campana);

	const res = await api.post("cambioEstadoParte.php", payload);
	return res.data;
};

export const updateRecolectorParteCheckInformativo = async ({
	id_cuadrilla,
	id_recolector_ptegrupo,
	check_informativo,
} = {}) => {
	const res = await api.post("checkInformativoRecolectorParte.php", {
		id_cuadrilla: Number(id_cuadrilla),
		id_recolector_ptegrupo: Number(id_recolector_ptegrupo),
		check_informativo: Number(check_informativo),
	});
	return res.data;
};

export const getDatosFiltros = async () => {
	const res = await api.get("getDatosFiltros.php");
	return res.data;
};

export const getPartesGrupoFiltros = async ({ fechaDesde, fechaHasta } = {}) => {
	const res = await api.get("partesGrupoFiltros.php", {
		params: {
			fechaDesde,
			fechaHasta,
		},
	});
	return res.data;
};

export const getOpcionesDocumentacion = async () => {
	const res = await api.get("opcionesDocumentacion.php");
	return res.data;
};

export const getDetallePersona = async (id_usuario) => {
	const res = await api.get("detallePersona.php", {
		params: { id_usuario },
	});
	return res.data;
};

export const getDocumentosPersona = async (id_usuario) => {
	const res = await api.get("documentosPersonaCarpetas.php", {
		params: {
			id_usuario,
		},
	});
	return res.data;
};

export const getListadoDocumentosPersona = async () => {
	const res = await api.get("listadoDocumentosPersona.php");
	return res.data;
};

export const getCarpetasDocumentacion = async () => {
	const res = await api.get("carpetasDocumentacion.php");
	return res.data;
};

export const crearCarpetaDocumentacion = async (payload = {}) => {
	const res = await api.post("carpetasDocumentacion.php", payload);
	return res.data;
};

export const actualizarCarpetaDocumentacion = async (payload = {}) => {
	const res = await api.put("carpetasDocumentacion.php", payload);
	return res.data;
};

export const eliminarCarpetaDocumentacion = async (id) => {
	const res = await api.delete("carpetasDocumentacion.php", {
		data: { id },
	});
	return res.data;
};

export const getPermisosDocumentacion = async () => {
	const res = await api.get("permisosDocumentacion.php");
	return res.data;
};

export const actualizarPermisosDocumentacion = async (data = []) => {
	const res = await api.put("permisosDocumentacion.php", {
		data,
	});
	return res.data;
};

export const subirDocumentosPersona = async (id_usuario, documentos = [], options = {}) => {
	const formData = new FormData();
	formData.append("id_usuario", String(id_usuario ?? ""));
	formData.append(
		"id_carpeta_documentacion",
		String(options?.id_carpeta_documentacion ?? options?.id_carpeta ?? "")
	);

	if (options?.fecha_caducidad) {
		formData.append("fecha_caducidad", String(options.fecha_caducidad));
	}

	documentos.forEach((documento) => {
		if (documento instanceof File) {
			formData.append("documentos[]", documento, documento?.name || "documento");
		}
	});

	const res = await api.post("subirDocumentosPersona.php", formData);
	return res.data;
};

export const descargarDocumentoPersona = async (id_documento) => {
	const res = await api.get("descargarDocumentoPersona.php", {
		params: { id_documento },
		responseType: "blob",
	});

	return {
		blob: res.data,
		fileName: extractFileNameFromContentDisposition(
			res.headers?.["content-disposition"]
		),
		contentType: res.headers?.["content-type"] || "",
	};
};

export const eliminarDocumentoPersona = async (id_documento) => {
	const res = await api.delete("eliminarDocumentoPersona.php", {
		data: { id_documento },
	});
	return res.data;
};

const resolveHistorialFichajeEstado = (item = {}) => {
	const explicitState =
		typeof item?.estado_comprobacion === "string" && item.estado_comprobacion.trim() !== ""
			? item.estado_comprobacion.trim()
			: typeof item?.estado === "string" && item.estado.trim() !== ""
				? item.estado.trim()
				: "";

	if (explicitState) {
		return explicitState;
	}

	const comprobado = Number(item?.comprobado ?? 0);
	const respuesta = item?.respuesta_comprobacion;

	if (comprobado === 0) {
		return "pendiente";
	}

	if (respuesta !== null && respuesta !== undefined && Number(respuesta) === 1) {
		return "validado";
	}

	if (respuesta !== null && respuesta !== undefined && Number(respuesta) === 0) {
		return "no_reconocido";
	}

	if (comprobado === 1) {
		return "comprobado";
	}

	return "pendiente";
};

export const normalizeHistorialFichajesPersonaItems = (items = []) =>
	(Array.isArray(items) ? items : []).map((item) => {
		const estado = resolveHistorialFichajeEstado(item);

		return {
			...item,
			id: Number(item?.id ?? 0) || null,
			id_cuadrilla: Number(item?.id_cuadrilla ?? 0) || null,
			id_empleo: Number(item?.id_empleo ?? 0) || null,
			comprobado: Number(item?.comprobado ?? 0) || 0,
			respuesta_comprobacion:
				item?.respuesta_comprobacion === null || item?.respuesta_comprobacion === undefined
					? null
					: Number(item.respuesta_comprobacion),
			puntuacion_comprobacion:
				item?.puntuacion_comprobacion === null || item?.puntuacion_comprobacion === undefined
					? null
					: Number(item.puntuacion_comprobacion),
			fecha_cuadrilla: item?.fecha_cuadrilla || item?.fecha || item?.fecha_dia || null,
			fecha_comprobacion: item?.fecha_comprobacion || null,
			fecha_exportado:
				item?.fecha_exportado || item?.fecha_exportado_in || item?.fecha_exportado_out || null,
			nombre_cuadrilla:
				item?.nombre_cuadrilla ||
				item?.nombre_parte ||
				(item?.id_cuadrilla ? `Parte ${item.id_cuadrilla}` : ""),
			nombre_cliente: item?.nombre_cliente || "",
			imagen_url: item?.imagen_url || item?.url_imagen_endpoint || null,
			estado_comprobacion: estado,
			estado_label: item?.estado_label || estado,
		};
	});

const normalizeHistorialFichajesPersonaResponse = (payload, fallbackPage = 1, fallbackLimit = 40) => {
	if (!payload || payload.success !== true) {
		return payload;
	}

	const items = Array.isArray(payload?.data)
		? payload.data
		: Array.isArray(payload?.data?.historial)
			? payload.data.historial
			: Array.isArray(payload?.data?.items)
				? payload.data.items
				: Array.isArray(payload?.historial)
					? payload.historial
					: Array.isArray(payload?.items)
						? payload.items
						: [];

	const paginationSource =
		payload?.pagination ||
		payload?.data?.pagination ||
		{};

	const page = Number(
		paginationSource?.page ??
		payload?.page ??
		fallbackPage
	) || fallbackPage;

	const limit = Number(
		paginationSource?.limit ??
		payload?.limit ??
		fallbackLimit
	) || fallbackLimit;

	const normalizedItems = normalizeHistorialFichajesPersonaItems(items);
	const hasMoreExplicit = paginationSource?.has_more;
	const hasMore =
		typeof hasMoreExplicit === "boolean"
			? hasMoreExplicit
			: normalizedItems.length >= limit;

	return {
		...payload,
		data: normalizedItems,
		pagination: {
			...paginationSource,
			page,
			limit,
			has_more: hasMore,
		},
	};
};

export const getHistorialFichajesPersona = async (id_usuario, page = 1, limit = 40) => {
	const params = { id_usuario, page, limit };

	try {
		const res = await api.get("historialFichajePersona.php", { params });
		return normalizeHistorialFichajesPersonaResponse(res.data, page, limit);
	} catch (error) {
		if (error?.response?.status !== 404) {
			throw error;
		}

		const legacyRes = await api.get("historialFichajesPersona.php", { params });
		return normalizeHistorialFichajesPersonaResponse(legacyRes.data, page, limit);
	}
};

export const verificarSesionActiva = async () => {
	const res = await api.get("VerificarToken.php", {
		headers: {
			"Cache-Control": "no-cache",
			Pragma: "no-cache",
		},
	});
	return res.data;
};

export const sincronizar = async (payload = {}) => {
	const res = await api.post("sincronizartrabajadores.php", payload, {
		timeout: 300000,
	});
	return res.data;
};

export const getSincronizacionesEoer = async ({
	limit = 30,
	origen = "todos",
	estado = "todos",
} = {}) => {
	const res = await api.get("sincronizacionesEoer.php", {
		params: {
			limit,
			origen,
			estado,
		},
	});
	return res.data;
};

export const createSincronizacionEoer = async (payload) => {
	const res = await api.post("sincronizacionesEoer.php", {
		action: "create",
		...payload,
	});
	return res.data;
};

export const updateSincronizacionEoer = async (id, payload) => {
	const res = await api.post("sincronizacionesEoer.php", {
		action: "update",
		id,
		...payload,
	});
	return res.data;
};

export const toggleSincronizacionEoer = async (id) => {
	const res = await api.post("sincronizacionesEoer.php", {
		action: "toggle",
		id,
	});
	return res.data;
};

export const deleteSincronizacionEoer = async (id) => {
	const res = await api.post("sincronizacionesEoer.php", {
		action: "delete",
		id,
	});
	return res.data;
};

export const getConvenios = async () => {
	const res = await api.get("convenios.php");
	return res.data;
};

export const createConvenio = async (payload) => {
	const res = await api.post("convenios.php", {
		action: "create",
		...payload,
	});
	return res.data;
};

export const updateConvenio = async (id, payload) => {
	const res = await api.post("convenios.php", {
		action: "update",
		id,
		...payload,
	});
	return res.data;
};

export const deleteConvenio = async (id) => {
	const res = await api.post("convenios.php", {
		action: "delete",
		id,
	});
	return res.data;
};
